<template>
	<img 
		class="img-fit w-100 h-100"
		v-if="targetAreaName"
		:src="targetAreaImage"
	> 
</template>

<script>
export default {
	data() {
		return {
      // HACK: 要リファクタリング
			targetAreaIcon: {
        '営業': 'dept_sales.png',
        'マーケティング': 'dept_marketing.png',
        '経営': 'dept_corporate.png',
        '戦略': 'dept_strategy.png',
        'マネジメント': 'dept_management.png',
        '事務（バックオフィス）': 'dept_backoffice.png',
        'カスタマーサクセス': 'dept_cs.png',
        'コールセンター': 'dept_callcenter.png',
        'ヘルプデスク': 'dept_helpdesk.png',
        '人事': 'dept_hr.png',
        '経理': 'dept_accounting.png',
        '財務会計': 'dept_finance.png',
        '製造部': 'dept_manufacture.png',
        '品質管理': 'dept_qc.png',
        'IT部門': 'dept_it.png',
        'セキュリティ': 'dept_security.png',
        '購買': 'dept_purchase.png',
        '物流': 'dept_logistics.png',
        '研究開発': 'dept_rd.png',
        '生産': 'dept_production.png',
        '法務': 'dept_legal.png',
        'その他': 'dept_others.png'
      }
		}
	}, 
	props: {
		targetAreaName: {
      type: String,
      default: null
    }
	},
	computed: {
		targetAreaImage() {
			if (this.targetAreaName) {
				return require(`../../../../assets/images/target_area_icon/${this.targetAreaIcon[this.targetAreaName]}`)
			}
    }
	}
}
</script>
